import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-float";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";
import _typeof from "D:/work/Code/\u9676\u51B6/new_hundred_web_ts/hundred_web_ts/node_modules/@babel/runtime/helpers/esm/typeof";
import { __assign, __awaiter, __generator, __read, __values } from "tslib";
import { wxApi } from './api';
import store from '@/store/index';
import querystring from 'querystring';
import Thumbnail from '@forzoom/thumbnail';
import router from '@/router';
import { format as $mathFormat, chain as $mathChain, bignumber as $mathBignumber } from 'mathjs';
import { createDecorator } from 'vue-class-component';
var ch = [null, '一', '二', '三', '四', '五', '六', '七', '八', '九'];
var chWeekDay = ['日', '一', '二', '三', '四', '五', '六', '日'];
var monthDay = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var shareList = ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone'];
/**
 * 是否是闰年
 */

export function isLeapYear(year) {
  if (year % 4 !== 0) {
    return false;
  }

  if (year % 400 === 0) {
    return true;
  }

  if (year % 100 === 0) {
    return false;
  }

  return true;
}
/**
 * 获得一个月有多少天
 *
 * @param {} year
 * @param {} month 1-12
 */

export function getMonthDay(year, month) {
  if (isLeapYear(year) && month === 2) {
    return 29;
  }

  return monthDay[month];
}
/**
 * 等待毫秒数
 */

export function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
}
/**
 * 获得querystring
 *
 * @return {object} 返回qs
 */

export function getQS(url) {
  var query = url || location.search;
  var posInSearch = query.indexOf('?');
  return querystring.parse(query.substr(posInSearch + 1));
}
/**
 * 是否是null或者undefined
 *
 * @param {} v 参数
 *
 * @return {boolean}
 */

export function isUndef(v) {
  return v === null || v === undefined;
}
/**
 * 金额格式化
 * @param {*} v 金额数据
 * @param {string} division 除数
 * @param {string} precision 精度
 */

export function currency(v, division, precision) {
  if (division === void 0) {
    division = 100;
  }

  if (precision === void 0) {
    precision = 2;
  }

  if (isUndef(v)) {
    return v;
  }

  var result = String((v / division).toFixed(precision));
  var pos = result.indexOf('.00');

  if (pos !== -1) {
    return result.substr(0, pos);
  } else {
    return result;
  }
}
/**
 * 返回weekDay的中文
 *
 * @param {Date} date
 */

export function toChWeekDay(date, format) {
  if (isUndef(date)) {
    return date;
  }

  var day = new Date(date.valueOf() - 8 * 3600000).getUTCDay();

  if (isUndef(chWeekDay[day])) {
    return day;
  }

  if (!isUndef(format)) {
    return format.replace(/d/g, chWeekDay[day]);
  } else {
    return chWeekDay[day];
  }
}
/**
 * 获得当前的时间
 *
 * @return {Date} 当天
 */

export function dateNow() {
  var utcDate = new Date(new Date().valueOf() + 8 * 3600000);
  var year = utcDate.getUTCFullYear();
  var month = utcDate.getUTCMonth() + 1;
  var date = utcDate.getUTCDate();
  var hour = utcDate.getUTCHours();
  var minute = utcDate.getUTCMinutes();
  var second = utcDate.getUTCSeconds();
  return dateParse(year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second);
}
/**
 * 日期格式化
 *
 * @param {Date|Number} v UTC+08:00
 * @param {String} format 格式内容
 *
 * @return {string} 经过format的日期数据
 */

export function dateFormat(v, format) {
  var oldV = v;

  var type = _typeof(v);

  if (isUndef(v) || type !== 'number' && !(v instanceof Date)) {
    return v;
  } // 使用默认的format


  if (!format) {
    format = 'Y-m-d';
  }

  if (typeof v === 'number') {
    v = new Date(v - 8 * 3600000);
  } else {
    v = new Date(v.valueOf() - 8 * 3600000);
  }

  var vc = null;

  if (format.indexOf('D') > -1 || format.indexOf('M') > -1) {
    if (typeof oldV === 'number') {
      vc = new Date(oldV);
    } else {
      vc = new Date(oldV.valueOf());
    }
  }

  format = format.replace('Y', String(v.getUTCFullYear()));
  format = format.replace('m', String(_format(v.getUTCMonth() + 1)));
  format = format.replace('d', String(_format(v.getUTCDate())));

  if (vc) {
    format = format.replace('M', String(_format(vc.getMonth() + 1)));
    format = format.replace('D', String(_format(vc.getDate())));
  }

  format = format.replace('H', String(_format(v.getUTCHours())));
  format = format.replace('i', String(_format(v.getUTCMinutes())));
  format = format.replace('s', String(_format(v.getUTCSeconds())));
  return format;
}
/**
 * 移动日期
 *
 * @param {Date} v 传入进来的日期
 * @param {} day
 */

export function dateOffset(v, day) {
  if (isUndef(v)) {
    return v;
  }

  return new Date(v.valueOf() + day * 86400000);
}
/**
 * 日期天数差距
 *
 * @param {} v 较小的日期
 * @param {} c 比较的日期
 *
 * @return {number} 差距天数，当差距小于1天的时候，将不进行处理
 */

export function dateDiff(v, c) {
  if (isUndef(v)) {
    return v;
  }

  return Math.floor((c.valueOf() - v.valueOf()) / 86400000);
}
export function dateParse(v) {
  if (isUndef(v) || v === '') {
    return v;
  }

  var chunk = v.split(' ');
  var date = chunk[0];
  var time = chunk[1];
  var dateChunk = date.split('-');
  var d = new Date();
  d.setUTCFullYear(Number(dateChunk[0]));
  d.setUTCMonth(Number(dateChunk[1]) - 1);
  d.setUTCMonth(Number(dateChunk[1]) - 1);
  d.setUTCDate(Number(dateChunk[2]));
  var hour = 0;
  var minute = 0;
  var second = 0;

  if (!isUndef(time)) {
    var timeChunk = time.split(':');
    hour = Number(timeChunk[0]);
    minute = Number(timeChunk[1]);
    second = Number(timeChunk[2]);
  }

  d.setUTCHours(hour);
  d.setUTCMinutes(minute);
  d.setUTCSeconds(second);
  d.setUTCMilliseconds(0);
  return new Date(d.valueOf() + 8 * 3600000);
}
/**
 * 获得当天的Date，要求北京时区
 *
 * @return {Date} 当天日期，UTC时间+8小时
 */

export function dateToday() {
  var utcDate = new Date(new Date().valueOf() + 8 * 3600000);
  return dateParse(utcDate.getUTCFullYear() + "-" + (utcDate.getUTCMonth() + 1) + "-" + utcDate.getUTCDate() + " 00:00:00");
}
/**
 * 某一天之后的第一个day
 *
 *  - 当是同一个day的时候会获取当天(默认行为)，当inclusive = false是，将会寻找下一周的同一day
 *
 * @param {} date 某一天的日期
 * @param {} day 周几
 * @param {} inclusive = true 是否包含当天
 */

export function dateNext(date, day, inclusive) {
  if (inclusive === void 0) {
    inclusive = true;
  }

  var offset = (day - date.getDay() + 7) % 7;

  if (!inclusive && offset === 0) {
    offset = 7;
  } // 得到今天后的周几那天的日期


  return dateOffset(date, offset);
}
export function getYear(date) {
  return date.getUTCFullYear();
}
export function getMonth(date) {
  return date.getUTCMonth();
}
export function getDay(date) {
  return date.getUTCDay();
}
/**
 * 转换成[x天]xx:xx:xx格式
 * @param minute 允许小数
 */

export function minuteFormat(minute) {
  var day = Math.floor(minute / 1440);
  var dayStr = day > 0 ? day + '天' : '';
  return dayStr + (_format(Math.floor(minute / 60) % 24) + ":" + _format(Math.floor(minute % 60)) + ":" + _format(Math.round(minute % 1 * 60)));
}
export function paceFormat(pace) {
  return Math.floor(pace) + "'" + _format(Math.floor(pace % 1 * 60)) + "\"";
}
/**
 * 获取配速
 * @param distance 距离，公里
 * @param time 时长，分钟
 */

export function getPace(distance, time) {
  return time / distance;
}
export function floorOrFixed(val, precision) {
  if (precision === void 0) {
    precision = 2;
  }

  var str = val + '';
  return str.indexOf('.') >= 0 ? val.toFixed(2) : str;
}
/**
 * 对于数字进行format操作
 */

export function _format(n) {
  if (n >= 0 && n < 10) {
    return '0' + n;
  } else {
    return "" + n;
  }
} // 设置分享话术

export function registerShare(option, disableShare) {
  var _this = this;

  if (disableShare === void 0) {
    disableShare = false;
  }

  console.log('target 分享option', option); //   if ((window as any).wxstatus != 'ready') {
  //     setTimeout(() => {
  //       registerShare(option, disableShare);
  //     }, 1000);
  //     return;
  //   }

  if (!option.title) {
    option.title = '';
  }

  if (!option.desc) {
    option.desc = '百日跑，看到坚持的力量！';
  }

  if (!option.link) {
    option.link = {
      path: router.currentRoute.fullPath
    };
  }

  if (option.link && typeof option.link !== 'string') {
    var basicInfo = store.state.user.basicInfo;
    var referrer = basicInfo ? {
      referrer: basicInfo.id
    } : {};

    var qs = __assign(__assign(__assign({}, getQS()), referrer), option.link.query ? option.link.query : {});

    var path = null;

    if (isString(option.link.path)) {
      path = option.link.path;
    } else if (isPlainObject(option.link.path)) {
      path = router.resolve(option.link.path).resolved.fullPath;
    }

    option.link = "" + window.pageUrl + window.appPageRoot + "?" + querystring.stringify(qs) + "#" + path;
  }

  if (!option.imgUrl) {
    var basicInfo = store.state.activity.basicInfo[store.getters['activity/activityId']];

    if (basicInfo) {
      option.imgUrl = basicInfo.share_logo;
    }
  }

  if (typeof wx !== 'undefined') {
    store.commit('addJSSDKReadyCallback', function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (wx.updateAppMessageShareData && isFunction(wx.updateAppMessageShareData)) {
                // 这个是分享接口
                // @ts-ignore
                wx.updateAppMessageShareData(option);
              }

              if (wx.updateTimelineShareData && isFunction(wx.updateTimelineShareData)) {
                // @ts-ignore
                wx.updateTimelineShareData(option);
              }

              return [4
              /*yield*/
              , Promise.all([// @ts-ignore
              wxApi.onMenuShareTimeline(__assign({}, option)), // @ts-ignore
              wxApi.onMenuShareAppMessage(__assign({}, option)), // @ts-ignore
              wxApi.onMenuShareQQ(__assign({}, option)), // @ts-ignore
              wxApi.onMenuShareWeibo(__assign({}, option)), // @ts-ignore
              wxApi.onMenuShareQZone(__assign({}, option))])["catch"](function (err) {})];

            case 1:
              _a.sent();

              return [2
              /*return*/
              ];
          }
        });
      });
    });
  }
}
/**
 * 去除字符串中的空格
 * @param  String str 需要去除空格的字符串
 */

export function removeAllSpace(str) {
  return str ? str.replace(/\s+/g, '') : '';
}
/**
 * 加载图片
 */

export function loadImage(src, anonymous) {
  return new Promise(function (resolve, reject) {
    var image = new Image();

    if (anonymous) {
      image.setAttribute('crossOrigin', 'anonymous');
    }

    image.onload = function () {
      resolve(image);
    };

    image.onerror = function (e) {
      reject(e);
    };

    image.src = src;
  });
}
/**
 * 加载资源
 */

export function loadScript(path) {
  if (typeof wx !== 'undefined') {
    return;
  }

  return new Promise(function (resolve, reject) {
    // 尝试重新加载wx内容
    var $script = document.createElement('script');
    $script.setAttribute('src', 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js');

    $script.onload = function () {
      resolve();
    };

    document.body.appendChild($script);
  });
}
export var is = {
  weixin: function weixin() {
    return /MicroMessenger/.test(navigator.userAgent);
  },
  tourye: function tourye() {
    return /Tourye/.test(navigator.userAgent);
  },
  bairipao: function bairipao() {
    return /Bairipao/.test(navigator.userAgent);
  },

  /** 是否是iPhone设备 */
  iPhone: function iPhone() {
    return /iPhone/.test(navigator.userAgent);
  },

  /** 设备是否是iPhoneX/XS/XSMax/XR */
  iPhoneXSeries: function iPhoneXSeries() {
    return is.iPhoneXOrXS() || is.iPhoneXSMax() || is.iPhoneXSMax() || is.iPhoneXR();
  },

  /** iPhoneXSMax */
  iPhoneXOrXS: function iPhoneXOrXS() {
    return is.iPhone() && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
  },

  /** iPhoneXSMax */
  iPhoneXSMax: function iPhoneXSMax() {
    return is.iPhone() && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
  },

  /** iPhoneR */
  iPhoneXR: function iPhoneXR() {
    return is.iPhone() && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
  }
};
/**
 * 生成map
 * @param {} arr
 * @param {} key
 */

export function makeMap(arr, key, setter) {
  var map = {};

  for (var i = 0, len = arr.length; i < len; i++) {
    map[arr[i][key]] = setter ? setter(arr[i]) : arr[i];
  }

  return map;
}
export var px2 = {
  rem6: function rem6(px) {
    return px / 37.5;
  },
  toPx: function toPx(rem) {
    return rem * 37.5;
  }
};
/**
 * 获得当前的时间
 *
 * @return {Date} 当天
 */

export function serverDateNow() {
  if (!store.state.util.timestamp) {
    return dateNow();
  }

  var timestamp = store.state.util.timestamp * 1000;
  var utcDate = new Date(timestamp + 8 * 3600000);
  var year = utcDate.getUTCFullYear();
  var month = utcDate.getUTCMonth() + 1;
  var time = utcDate.getUTCDate() + " " + utcDate.getUTCHours() + ":" + utcDate.getUTCMinutes() + ":" + utcDate.getUTCSeconds();
  return dateParse(year + "-" + month + "-" + time);
}
export function camelCase(key) {
  return key.replace(/[-_][a-z0-9]/g, function (c) {
    return c.substr(1).toUpperCase();
  });
}
/**
 * 处理placeholder
 *
 * @param {} val
 * @param {} text
 */

export function placeholder(val, text, extra) {
  if (isUndef(val) || val === extra) {
    return text;
  }

  return val;
} // 禁用分享

export function disableShare() {
  if (typeof wx !== 'undefined') {
    store.commit('addJSSDKReadyCallback', function () {
      // @ts-ignore
      wxApi.hideMenuItems({
        menuList: shareList
      });
    });
  }
} // 启用分享

export function enableShare() {
  if (typeof wx !== 'undefined') {
    store.commit('addJSSDKReadyCallback', function () {
      // @ts-ignore
      wxApi.showMenuItems({
        menuList: shareList
      });
    });
  }
}
export function supportWebp() {
  if (typeof window === 'undefined') {
    return false;
  }

  var support = true;
  var d = document;

  try {
    var el = d.createElement('object');
    el.type = 'image/webp';
    el.style.visibility = 'hidden';
    el.innerHTML = '!';
    d.body.appendChild(el);
    support = !el.offsetWidth;
    d.body.removeChild(el);
  } catch (err) {
    support = false;
  }

  return support;
}
export var isSupportWebp = supportWebp();
export var platform = '';
export function getPlatform() {
  if (!platform) {
    platform = is.weixin() ? 'weixin' : 'web';
  }

  return platform;
}
/** 获取定位 */

export function getWxLocation() {
  if (!is.weixin()) {
    // 返回void则表明不处理
    return Promise.resolve();
  }

  return new Promise(function (resolve, reject) {
    store.commit('addJSSDKReadyCallback', function () {
      wx.getLocation({
        type: 'gcj02',
        // @ts-ignore
        success: function success(res) {
          if (res.errMsg === 'getLocation:ok') {
            resolve({
              status: 'success',
              res: {
                latitude: res.latitude,
                longitude: res.longitude,
                speed: res.speed,
                accuracy: res.accuracy
              }
            });
          } else {
            resolve({
              status: 'error',
              result: res.errMsg,
              message: res.errMsg
            });
          }
        },
        // @ts-ignore
        fail: function fail(res) {
          resolve({
            status: 'error',
            result: res.errMsg,
            message: res.errMsg
          });
        }
      });
    });
  });
}
/**
 * 是否是某种类型
 */

export function isType(name) {
  return function (val) {
    return Object.prototype.toString.call(val) === "[object " + name + "]";
  };
}
export var isArray = Array.isArray || isType('Array');
export var isString = isType('String');
export var isNumber = isType('Number');
export var isFunction = isType('Function');
export var isPlainObject = isType('Object');
export function replace(str, data) {
  var e_1, _a, e_2, _b;

  if (!str) {
    return str;
  }

  var result = [];

  if (!isArray(str)) {
    result.push(str);
  }

  var pending = [];

  for (var i = 0; i < result.length; i++) {
    if (!result[i]) {
      continue;
    }

    var pos = result[i].indexOf('${');

    if (pos >= 0) {
      pending.push(i);
    }
  }

  var keys = Object.keys(data);
  var regex = null;

  try {
    for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
      var key = keys_1_1.value;
      regex = new RegExp('\\${' + key + '}', 'g');

      try {
        for (var pending_1 = (e_2 = void 0, __values(pending)), pending_1_1 = pending_1.next(); !pending_1_1.done; pending_1_1 = pending_1.next()) {
          var index = pending_1_1.value;
          result[index] = result[index].replace(regex, data[key]);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (pending_1_1 && !pending_1_1.done && (_b = pending_1["return"])) _b.call(pending_1);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (keys_1_1 && !keys_1_1.done && (_a = keys_1["return"])) _a.call(keys_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return isArray(str) ? result : result[0];
}
export function repeat(str, times) {
  var result = '';

  for (var i = 0; i < times; i++) {
    result += '*';
  }

  return result;
}
export function securityText(str, rule) {
  if (!str) {
    return;
  }

  var parts = rule.split('|');

  for (var i = 0, len = parts.length; i < len; i++) {
    var part = parts[i];

    var _a = __read(part.split(':'), 2),
        key = _a[0],
        value = _a[1];

    var reverse = key[0] === '!';
    var pureKey = key[0] === '!' ? key.substr(1) : key;
    var strlen = str.length;

    switch (pureKey) {
      // 从head开始计算
      case 'head':
        var hpos = Number(value);
        str = !reverse ? repeat('*', hpos) + str.substring(hpos) : str.substring(0, hpos) + repeat('*', str.length - hpos);
        break;
      // 从tail开始计算

      case 'tail':
        var tpos = Number(value);
        str = !reverse ? str.substring(0, strlen - tpos) + repeat('*', tpos) : repeat('*', strlen - tpos) + str.substring(strlen - tpos);
        break;
    }
  }

  return str;
}
export function isPopupDisplay(route, tag) {
  if (!route.meta) {
    return;
  }

  var popup = route.meta.popup;
  return popup === true || popup && (popup === tag || popup.indexOf(tag) >= 0);
}
/** 文字过长处理
 *
 * @param {string} str 需要处理的文字
 * @param {number} limit 文字长度限制
 */

export function overlongTextProcessing(str, limit) {
  if (str.length < limit) {
    return str;
  }

  return str.slice(0, limit) + "...";
}
var bodyEl = document.body;
var enabled = false;
var top = 0;
export function enableBodyScroll() {
  if (!enabled) {
    bodyEl.style.position = '';
    bodyEl.style.top = '';
    window.scrollTo(0, top); // 回到原先的top

    enabled = true;
  }
}
export function disableBodyScroll() {
  top = window.pageYOffset;
  bodyEl.style.position = 'fixed';
  bodyEl.style.top = -top + 'px';
  enabled = false;
}
/**
 * 显示图片
 * @param current 当前显示图片
 * @param urls 全部图片
 */

export function showImagePopup(current, urls) {
  if (is.weixin()) {
    wx.previewImage({
      current: current,
      urls: urls
    });
  }
}
export function gMTToStr(time) {
  var date = new Date(time);
  var str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
  return str;
}
export function gMTToStrDay(time) {
  var date = new Date(time);
  var str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  return str;
}
export function traverse(obj, keyOrPath) {
  var e_3, _a;

  if (!isArray(keyOrPath)) {
    keyOrPath = keyOrPath.split('.');
  }

  if (keyOrPath.length === 1) {
    return obj[keyOrPath[0]];
  } else {
    var last = keyOrPath.pop();

    try {
      for (var keyOrPath_1 = __values(keyOrPath), keyOrPath_1_1 = keyOrPath_1.next(); !keyOrPath_1_1.done; keyOrPath_1_1 = keyOrPath_1.next()) {
        var part = keyOrPath_1_1.value;
        obj = obj[part]; // 寻找失败

        if (!obj || _typeof(obj) !== 'object') {
          return;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (keyOrPath_1_1 && !keyOrPath_1_1.done && (_a = keyOrPath_1["return"])) _a.call(keyOrPath_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return obj[last];
  }
}
export var imageFilter = Thumbnail.generateImageFilter({
  bed: {
    aliyun: 'https://static.run100.runorout.cn',
    testAliyun: 'http://static.ro-test.xorout.com',
    "default": 'https://static.run100.runorout.cn'
  },
  isAliyun: function isAliyun(listener, options) {
    return /static.run100.runorout.cn/.test(listener.src) || /static.ro-test.xorout.com/.test(listener.src);
  }
});
export var EMPTY_LIST = {
  list: [],
  loaded: false,
  requesting: false
};
/**
 * 生成key
 */

export function getMapKey(obj) {
  var keys = Object.keys(obj); // @ts-ignore

  return keys.sort() // @ts-ignore
  .map(function (key) {
    return isUndef(obj[key]) ? '' : obj[key];
  }).join('_');
}
export function setTitle(title) {
  document.title = title;
  var mobile = navigator.userAgent.toLowerCase();

  if (/iphone|ipad|ipod/.test(mobile) && /MicroMessager/.test(mobile)) {
    var iframe_1 = document.createElement('iframe');
    iframe_1.style.visibility = 'hidden'; // 替换成站标favicon路径或者任意存在的较小的图片即可

    iframe_1.setAttribute('src', window.pageUrl + "/favicon.ico");

    var iframeCallback_1 = function iframeCallback_1() {
      setTimeout(function () {
        iframe_1.removeEventListener('load', iframeCallback_1);
        document.body.removeChild(iframe_1);
      }, 0);
    };

    iframe_1.addEventListener('load', iframeCallback_1);
    document.body.appendChild(iframe_1);
  }
}
/**
 * 精度计算，加减乘除
 */

export var math = {
  add: function add() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return comp('add', args);
  },
  subtract: function subtract() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return comp('subtract', args);
  },

  /** X */
  multiply: function multiply() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return comp('multiply', args);
  },

  /** % */
  divide: function divide() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return comp('divide', args);
  }
};

function comp(_func, args) {
  var t = $mathChain($mathBignumber(args[0]));

  for (var i = 1; i < args.length; i++) {
    // @ts-ignore
    t = t[_func]($mathBignumber(args[i]));
  } // 防止超过6位使用科学计数法


  return parseFloat($mathFormat(t.done()));
}

export function Arabia_To_SimplifiedChinese(Num) {
  if (typeof Num === 'string') {
    for (var i = Num.length - 1; i >= 0; i--) {
      Num = Num.replace(',', ''); // 替换Num中的“,”

      Num = Num.replace(' ', ''); // 替换Num中的空格
    }
  }

  if (isNaN(+Num)) {
    // 验证输入的字符是否为数字
    // alert("请检查小写金额是否正确");
    return;
  } // 字符处理完毕后开始转换，采用前后两部分分别转换


  var part = String(Num).split('.');
  var newchar = ''; // 小数点前进行转化

  for (var i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      // alert("位数过大，无法计算");
      return '';
    } // 若数量超过拾亿单位，提示


    var tmpnewchar = '';
    var perchar = part[0].charAt(i);

    switch (perchar) {
      case '0':
        tmpnewchar = '零' + tmpnewchar;
        break;

      case '1':
        tmpnewchar = '一' + tmpnewchar;
        break;

      case '2':
        tmpnewchar = '二' + tmpnewchar;
        break;

      case '3':
        tmpnewchar = '三' + tmpnewchar;
        break;

      case '4':
        tmpnewchar = '四' + tmpnewchar;
        break;

      case '5':
        tmpnewchar = '五' + tmpnewchar;
        break;

      case '6':
        tmpnewchar = '六' + tmpnewchar;
        break;

      case '7':
        tmpnewchar = '七' + tmpnewchar;
        break;

      case '8':
        tmpnewchar = '八' + tmpnewchar;
        break;

      case '9':
        tmpnewchar = '九' + tmpnewchar;
        break;
    }

    switch (part[0].length - i - 1) {
      case 0:
        tmpnewchar = tmpnewchar;
        break;

      case 1:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '十';
        }

        break;

      case 2:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '百';
        }

        break;

      case 3:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '千';
        }

        break;

      case 4:
        tmpnewchar = tmpnewchar + '万';
        break;

      case 5:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '十';
        }

        break;

      case 6:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '百';
        }

        break;

      case 7:
        if (+perchar !== 0) {
          tmpnewchar = tmpnewchar + '千';
        }

        break;

      case 8:
        tmpnewchar = tmpnewchar + '亿';
        break;

      case 9:
        tmpnewchar = tmpnewchar + '十';
        break;
    }

    newchar = tmpnewchar + newchar;
  } // 替换所有无用汉字，直到没有此类无用的数字为止


  while (newchar.search('零零') !== -1 || newchar.search('零亿') !== -1 || newchar.search('亿万') !== -1 || newchar.search('零万') !== -1) {
    newchar = newchar.replace('零亿', '亿');
    newchar = newchar.replace('亿万', '亿');
    newchar = newchar.replace('零万', '万');
    newchar = newchar.replace('零零', '零');
  } // 替换以“一十”开头的，为“十”


  if (newchar.indexOf('一十') === 0) {
    newchar = newchar.substring(1);
  } // 替换以“零”结尾的，为“”


  if (newchar.lastIndexOf('零') === newchar.length - 1 && newchar !== '零') {
    newchar = newchar.substring(0, newchar.length - 1);
  }

  return newchar;
}
var handlerMap = {};
/**
 * 合并调用并延迟，目前只能用于watch
 * @param delay 延迟毫秒
 */

export function WatchDelay(str, delay) {
  return createDecorator(function (options, key) {
    var handlerId = [options.name, str].join('_'); // @ts-ignore

    var originalMethodName = options.watch[str][0].handler; // @ts-ignore

    var originalMethod = options.methods[originalMethodName]; // @ts-ignore

    options.watch[str] = function wrapperMethod() {
      var _this = this;

      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var handler = handlerMap[handlerId];

      if (handler) {
        window.clearTimeout(handler);
        handlerMap[handlerId] = null;
      }

      handlerMap[handlerId] = window.setTimeout(function () {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            // @ts-ignore
            originalMethod.apply(this, args);
            handlerMap[handlerId] = null;
            return [2
            /*return*/
            ];
          });
        });
      }, delay);
    };
  });
}